import type { Component } from "solid-js";
import { createMemo } from "solid-js";

type NumberBadgeProps = {
  value: number;
  classList?: Record<string, boolean>;
};
const NumberBadge: Component<NumberBadgeProps> = (props) => {
  const isSingleDigit = createMemo(() => props.value >= 0 && props.value <= 9);

  return (
    <div
      class="inline-flex h-4 w-6 items-center justify-center rounded-3xl border-2 border-inverse px-1 text-small-medium text-inverse shadow-elevation-light-2"
      classList={{ "max-w-4": isSingleDigit(), ...props.classList }}
    >
      {props.value}
    </div>
  );
};

export default NumberBadge;
